export default __webpack_public_path__ + "static/social_share_dog-65d0920534dac8a4c6b6df61dd06def8.png";